 (()=>{
    const quantityPickers = document.querySelectorAll(".quantity-picker")
    quantityPickers.forEach((quantityPicker)=>{
      const decreaseBtn = quantityPicker.querySelector(".qty-btn[data-type='decrease']");
      const increaseBtn = quantityPicker.querySelector(".qty-btn[data-type='increase']");
      const quantityInput = quantityPicker.querySelector("input[name='quantity']");
    
      let quantity = 1;
    
      function updateDisplay() {
        quantityInput.value = quantity;
      }
    
      decreaseBtn.addEventListener('click', () => {
        if (quantity > 1) {
          quantity--;
          updateDisplay();
        }
      });
    
      increaseBtn.addEventListener('click', () => {
        quantity++;
        updateDisplay();
      });
    
      window.onload = updateDisplay;
    })
 })()